export const loadImages = async (urls) => {
  for (let i = 0; i < urls.length; i += 6) {
    const batch = urls.slice(i, i + 6);

    // Ждем загрузки всей пачки
    await Promise.all(
      batch.map((url) => {
        return new Promise((resolve) => {
          const img = new Image();
          img.onload = () => {
            resolve();
          };
          img.onerror = resolve;
          img.src = url;
        });
      }),
    );

    // Пауза между пачками
    await new Promise((resolve) => setTimeout(resolve, 50));
  }
};

export const loadAvatarAndAttach = (messages) => {
  const attaches = [];
  const avatars = [];

  for (const m of messages) {
    const attach = m?.message?.attachments?.[0]?.url;
    if (attach) attaches.push(attach);

    const avatar = m?.message?.image;
    if (avatar && avatar !== '1') avatars.push(avatar);
  }

  const urls = [...attaches, ...avatars];
  if (urls.length) loadImages(urls);
};
